import {HttpInterceptorService} from '@ispm/core/services/http-interceptor.service';
import {UserActionCreatorService} from '@ispm/user/services/user-action-creator.service';
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";
import {Injectable} from "@angular/core";
import {RouterManagerService} from "@ispm/core/services/router-manager.service";
import {LayoutEngineService} from "@ispm-client/modules/layout-engine/services/layout-engine.service";
import {ActivatedRoute, Router} from '@angular/router';
import {get} from 'lodash';

@Injectable({ providedIn: 'root' })
export class resolveClinicalDashboardForHome {
  constructor(private routerManagerService: RouterManagerService,
              private _http: HttpInterceptorService,
              private userActionCreatorService: UserActionCreatorService,
              private navigationConfigService: NavigationConfigService,
              private activatedRoute: ActivatedRoute) {
  }

  resolve() {
    let patientContext = this.activatedRoute.snapshot.data.patient;
    if (!patientContext) {
      this._http.get(`/patient/${this.routerManagerService.parameters.patientId}`)
        .map(data => {
          return data.json();
        }).subscribe(res => { this.userActionCreatorService.updatePatient(res.id, res); });
    } else {
      this.userActionCreatorService.updatePatient(this.routerManagerService.parameters.patientId, patientContext);
    }
    return {application: this.navigationConfigService.getCurrentApplicationId()};
  }
}

@Injectable({ providedIn: 'root' })
export class resolveClinicalDashboardWithMrn {
  constructor(private router: Router,
              private _http: HttpInterceptorService,
              private layoutEngineService: LayoutEngineService,
              private navigationConfigService: NavigationConfigService,
              private routerManagerService: RouterManagerService) {
  }

  resolve() {
    const mrn = this.routerManagerService.queryParameters.mrn;
    if (this.routerManagerService.queryParameters.patientId) {
      this.router.navigate(['ClinicalDashboard/'+this.routerManagerService.queryParameters.patientId], {queryParams : {mrn : mrn}});
    } else if (mrn) {
      this._http.get(`/patient`, { identifier: mrn})
        .map(data => {
          return data.json();
        })
        .subscribe((res) => {
          if (res && res.length > 0) {
            const navigationExtras = {
              queryParams: { mrn: mrn },
              state: { patient: res[0] }
            };
            this.router.navigate(['ClinicalDashboard', this.routerManagerService.queryParameters.patientId], navigationExtras);
          } else {
            const currentApp =  this.navigationConfigService.getCurrentAppFromSessionStorage();
            const params =  {"type":get(currentApp, 'alias')};
            const queryParams = {"appname": get(currentApp, 'alias')};
            this.layoutEngineService.showErrorMessagePopup('Patient Not Found',
              'No matching patient details for the provided Medical Record Number found.',
              'ERRROR',
              'dashboard/tabs/'+params.type,
              queryParams);
          }
        });
    }
  }
}
